/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createErf } from '../../factoriesAny.js';
export var erfDependencies = {
  typedDependencies: typedDependencies,
  createErf: createErf
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesErf.generated.js
// module id = 1538
// module chunks = 0